// Gedeelde formatters voor API-data. Losgetrokken uit store/modules/group.js
// zodat componenten ze kunnen importeren zonder de hele Vuex-store mee te
// trekken (group.js importeert de store zelf).
import { DateTime } from 'luxon'
import config from '@/utils/config'
import noImage from '@/assets/images/img_no-image.png'

export const getImageUrl = (imageObj, placeholder = true) => {
  if (imageObj) {
    return `${config.baseUrl}/api/attachments/${imageObj.container}/download/${imageObj.file}`
  } else {
    return placeholder ? noImage : null
  }
}

export const formatDate = {
  short: (date) => {
    return `${DateTime.fromISO(date).toLocaleString(DateTime.DATE_MED)}`
  },
  long: (date) => {
    return `${DateTime.fromISO(date).toLocaleString(DateTime.DATE_HUGE)}`
  },
  time: (date) => {
    return `${DateTime.fromISO(date).toLocaleString(DateTime.TIME_24_SIMPLE)}`
  }
}
